

export const RL_SELECTED_KEY = "RL:ITEMS:SELECTED";
export const SUPPLIERS_SELECTED_KEY = "RL:SUPPLIERS:SELECTED";
export const TENDER_SELECTED_KEY = "RL:TENDER:SELECTED";
export const REQUEST_CREATED_KEY = "RL:REQUEST:CREATED";
